/* eslint-disable react/no-unescaped-entities */
import React from 'react'

const Contact = () => {
  return (
    <div name='contact' className='w-full h-screen bg-[#0a192f] flex justify-center items-center p-4'>
      <form method='POST' action="https://getform.io/f/478f8d09-449b-41db-a39a-2697be069d80" className='flex flex-col max-w-[600px] w-full'>
        <div className='pb-8'>
          <p className='text-4xl font-bold inline border-b-4 border-blue-600 text-gray-300'>Contact</p>
          <p className='text-gray-300 py-4'>
            Submit the form below or reach me at:<br />
            Email: kwiste06@gmail.com<br />
            Phone: +250787239534<br />
            Address: KG 316 ST
          </p>
        </div>
        <input className='bg-[#ccd6f6] p-2' type="text" placeholder='Name' name='name' />
        <input className='my-4 p-2 bg-[#ccd6f6]' type="email" placeholder='Email' name='email' />
        <textarea className='bg-[#ccd6f6] p-2' name="message" rows="10" placeholder='Message'></textarea>
        <button className='text-white border-2 hover:bg-blue-600 hover:border-blue-600 px-4 py-3 my-8 mx-auto flex items-center'>Let's chat</button>
      </form>
    </div>
  )
}

export default Contact